import { Box, Button, } from '@mui/material'
import React from 'react'
import { PageWrapper } from 'src/elements'
import { CheckRounded, SyncSharp } from '@mui/icons-material'
import { useTypedSelector } from '../../../hooks'
import useActions from '../store/useActions'

const Imports = () => {
  const isOlxLoading = useTypedSelector(state => state.pages.imports.isOlxLoading)
  const isDomRiaLoading = useTypedSelector(state => state.pages.imports.isDomRiaLoading)
  const isOlxImportSuccess = useTypedSelector(state => state.pages.imports.isOlxImportSuccess)
  const isDomRiaImportSuccess = useTypedSelector(state => state.pages.imports.isDomRiaImportSuccess)
  const { startOlxImport, startDomRiaImport } = useActions()

  const handleOlxImportClick = async () => {
    if (isOlxLoading) {
      return
    }
    startOlxImport()
  }

  const handleDomRiaImportClick = async () => {
    if (isDomRiaLoading) {
      return
    }
    startDomRiaImport()
  }

  return (
    <PageWrapper>
      <Box sx={{ marginTop: '30px', display: 'flex', flexDirection: 'column', width: '300px', gap: '30px' }}>
        <Button
          variant="contained"
          type="button"
          startIcon={isOlxImportSuccess ? <CheckRounded/> : <SyncSharp/>}
          color={isOlxImportSuccess ? 'success' : 'primary'}
          onClick={() => handleOlxImportClick()}>
          {isOlxImportSuccess ? 'OLX імпорт запустився' : 'Запустити OLX імпорт'}
        </Button>
        <Button
          variant="contained"
          type="button"
          startIcon={isDomRiaImportSuccess ? <CheckRounded/> : <SyncSharp/>}
          color={isDomRiaImportSuccess ? 'success' : 'primary'}
          onClick={() => handleDomRiaImportClick()}>
          {isDomRiaImportSuccess ? 'DOM RIA імпорт запустився' : 'Запустити DOM RIA імпорт'}
        </Button>
      </Box>
    </PageWrapper>
  )
}

export default Imports
